import React from 'react';
// 1. Импортируем картинки из папки image (ЗАМЕНИ НАЗВАНИЯ ФАЙЛОВ НА СВОИ)
import iconWeb from '../image/web.ico';
import iconMobile from '../image/mobile.ico';
import iconServer from '../image/server.ico';
import iconWindows from '../image/windows.ico';
import iconAi from '../image/ai.ico';
import iconBD from '../image/bd.ico';
// 2. Подставляем переменные в массив
const servicesData = [
  {
    id: 1,
    title: "Веб-приложения",
    desc: "Создаем быстрые фронтенд-решения на React и надежные масштабируемые бэкенд-архитектуры на Node.js.",
    icon: iconWeb
  },
  {
    id: 2,
    title: "Мобильные приложения",
    desc: "Разработка современных и отзывчивых приложений для мобильных устройств с фокусом на идеальный UI/UX.",
    icon: iconMobile
  },
  {
    id: 3,
    title: "Серверное ПО",
    desc: "Проектирование высоконагруженных систем, REST API и баз данных для стабильной работы вашего бизнеса.",
    icon: iconServer
  },
  {
    id: 4,
    title: "ПО для Windows",
    desc: "Написание быстрого, нативного системного и прикладного программного обеспечения под Windows на языке C++.",
    icon: iconWindows
  },
  {
    id: 5,
    title: "Голосовые AI-агенты",
    desc: "Разработка интеллектуальных голосовых помощников для автоматизации звонков, поддержки клиентов и бизнес-процессов.",
    icon: iconAi
  },
  {
    id: 6,
    title: "Базы данных",
    desc: "Быстрое проектирование и развертывание баз данных и панели управления данными с разным уровнем доступа Админ, Модератор, Пользователь.",
    icon: iconBD
  }
];
function Development() {
  return (
    <div className="fade-in">
      <div className="page-header">
        <h1 className="page-title">Наши компетенции</h1>
        <p className="page-subtitle">Комплексная IT-разработка от нативных десктопных программ до современных веб-сервисов.</p>
      </div>
      
      <div className="services-grid">
        {servicesData.map(service => (
          <div key={service.id} className="card service-card">
            
            {/* 3. Меняем вывод: теперь это тег <img /> */}
            <div className="service-icon">
              <img src={service.icon} alt={service.title} />
            </div>
            
            <h3 className="service-title">{service.title}</h3>
            <p className="service-desc">{service.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
export default Development;